<tudi-menu></tudi-menu>
<div class="mt-3 " *ngIf="mode === 'list'">
  <div class="header-area">
    <div class="constraint-area">
      <div class="date-block">
        <div>
          <p-calendar [(ngModel)]="fromDate" dateFormat="yy/mm/dd" [appendTo]="'body'"></p-calendar>
        </div>
        <div>
          <span>~</span>
        </div>
        <div>
          <p-calendar [(ngModel)]="toDate" dateFormat="yy/mm/dd" [appendTo]="'body'"></p-calendar>
        </div>
      </div>
      <div>
        Patient Name: <input pInputText type="text" [(ngModel)]="name">
      </div>
      <div>
        Case ID: <input pInputText type="text" [(ngModel)]="caseIDStr">
      </div>
      <div *ngIf="isAdmin">
        <p-checkbox [(ngModel)]="onlyMe" [binary]="true"></p-checkbox>
        <span class="ml-3">Only List My Cases</span>
      </div>
      <div>
        Tagged: <p-dropdown [options]="tagOptions" [(ngModel)]="tag" optionLabel="label" placeholder="Do cases have tags" />
      </div>
      <div *ngIf="isAdmin">
        Tagger: <p-dropdown [options]="memberOptions" [(ngModel)]="tagger" optionLabel="label"
          placeholder="Select a tagger" />
      </div>
    </div>
    <div class="action-area">
      <div *ngIf="isShowCompareButton">
        <button pButton label="Compare Cases" (click)="onCompare()"></button>
      </div>
      <div>
        <button pButton label="Search" (click)="loadData()"></button>
      </div>
    </div>
  </div>
  <div *ngIf="totalCount > 0">Total Count: {{totalCount}}</div>
  <p-table [columns]="cols" [value]="cases" dataKey="id" responsiveLayout="stack" [breakpoint]="'720px'" 
    [paginator]="true" [rows]="pageSize" [(first)]="first" [lazy]="true" [totalRecords]="totalCount" (onLazyLoad)="onPageChange($event)">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th class="table-cell" *ngFor="let col of columns">{{ col.header }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
          <td [attr.colspan]="columns.length">
              No cases are found.
          </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-cols="columns">
      <tr (click)="onSelect(row)">
        <ng-container *ngFor="let col of cols">
          <ng-container [ngSwitch]="col.field">
            <td class="table-cell" *ngSwitchCase="'doctor'">
              <span class="p-column-title">{{ col.header }}: </span>{{row[col.field]}}
            </td>
            <td class="table-cell" *ngSwitchCase="'tongues'">
              <span class="p-column-title">{{ col.header }}: </span>
              <ng-container *ngFor="let tongue of getFilteredTongues(row[col.field]); let last = last">
                <span [style.color]="tongue.tagger.color" pTooltip="tagger: {{tongue.tagger.name}}" tooltipPosition="top">{{Utility.toTongueStr(tongue)}}</span>
                <span *ngIf="!last">, </span>
              </ng-container>
              <div class="tagger" *ngFor="let str of getTaggerStrs(row)">
                {{str}}
              </div>
            </td>
            <td class="table-cell" *ngSwitchDefault><span class="p-column-title">{{ col.header }}: </span>{{row[col.field]}}</td>
          </ng-container>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>
<tudi-case-dialog [case]="selectedCase" (tagging)="onStartTagging($event)" (edit)="onEdit($event)" (delete)="onDelete($event)"></tudi-case-dialog>
<app-case-edit-dialog [case]="selectedCase" (save)="onSaveEdit($event)" (cancel)="onCancelEdit($event)"></app-case-edit-dialog>
<tudi-case-tagging *ngIf="mode === 'tagging'" [patientCase]="selectedCase" (onUpdate)="onUpdateTags($event)" (onUpdateAndNext)="onUpdateTagsAndNext($event)" (onCancel)="onCancelTags()"></tudi-case-tagging>
<tudi-case-compare-dialog [cases]="compareCases"></tudi-case-compare-dialog>
